    
    import React, { useState,useEffect,useCallback,useMemo} from 'react';
    import IconButton from '@mui/material/IconButton';
    import CloseIcon from '@mui/icons-material/Close';
    import DeleteIcon from '@mui/icons-material/Delete';
    import {  useNavigate} from 'react-router-dom';
    import { alpha } from '@mui/material/styles';
  
    //import { styled } from '@mui/system';  // For styled
    import { styled } from "@mui/material/styles"; 
    import { DataGrid, gridClasses ,GridToolbar  } from '@mui/x-data-grid';
    import ConfirmationButton from './ConfirmationButton'
    import Helper from '../pages/Helper'
    import Pagination from '@mui/material/Pagination';
    import Stack from '@mui/material/Stack';
    import { Box } from '@mui/material';
    import { right } from '@popperjs/core';
    import { createTheme } from '@mui/material/styles';
    import CircularProgress from '@mui/material/CircularProgress';
    import Skeleton from '@mui/material/Skeleton';
import { isNumber } from '@mui/x-data-grid/internals';
     const GridNumberPaging =  ({customcolumns=null, rows=null, name, rowid = null, roleaccess= null, handleDynamicAction = null, width=null,disabledfieldsort=[],columvisibility={}}) => {
        const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
            [name] :columvisibility
        });
       
        const [newColumn, setNewColumn] = React.useState({
            [name] : []
        });

        const [newRowsTemp, setNewRowsTemp] = React.useState({
            [name]:[]
        });

         const [newRows, setNewRows] = React.useState({
            [name]:[]
        });

        const [totalRows, setTotalRows] = React.useState({
            [name]:0
        });
        const [gridPage, setGridPage] = React.useState({
            [name]:1
        });

        const [sortModel,setSortModel]= React.useState({
            [name]:[{
                field: rowid,
                sort : "asc"
            }]
        });

        const [filterModel , setFilterModel] = React.useState({
            [name] : {
                items: [],
                quickFilterExcludeHiddenColumns: true,
                quickFilterValues: [],
            }
        });
        
        const [isLoading,setIsLoading] = useState({[name] : false})
        
        const [selectedRowPerPage, setSelectedRowPerPage] = useState({[name] : "25"})
       
         const ODD_OPACITY = 0.2;

const StripedDataGrid = useCallback(styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
            theme.palette.action.selectedOpacity +
            theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
})),[]);

const Grid = () =>{
            setNewRowsTemp({[name]:[]})
            
            if(rows.length > 0)
                 {   
                     var newRow = rows.map(function(item,index) {  
                        
                         return {
                         //  No: index + 1,
                           ...item
                         }
                     })
                 
                     setNewRows({[name] : filterModel[name].quickFilterValues.length == 0 ? newRow : newRows[name]})
                     
                     setTotalRows({[name] : Math.ceil((filterModel[name].quickFilterValues.length == 0 ? newRow : newRows[name]).length / parseInt(selectedRowPerPage[name]))})
                    
                     if(customcolumns == null){
                         var columns = [];
                         var count = 0;
                         for(let key in newRows[name][0]) 
                             {
                                if(key == rowid){
                                     const myObj = {};
                                     const a = rowid;
                                     myObj[a] = false;
                                   
                                     setColumnVisibilityModel(myObj)
                                 }
                               
                                 switch (key) {
                                     case "button-delete":
                                         {
                                            var data = {
                                            // flex: 1,
                                            width: width[count],
                                            renderCell:(params) =>(
                                                     <ConfirmationButton classname='btn btn-danger' text="Do you want delete this data?" type="button"  title="Delete"  disabled={!roleaccess.DELETE}  onClick={() => handleDynamicAction(params.row)} >
                                                         <DeleteIcon sx={{ fontSize: 15 }}/> 
                                                     </ConfirmationButton>
                                                 )
                                             }
 
                                             columns.push(data);
                                             break;
                                         };
                                     case "button-update":
                                             {
                                                var data = {
                                                //  flex: 1,
                                                  width: width[count],
                                                 renderCell:(params) =>(
                                                         <button className='btn btn-success' title='Edit' onClick={(e) => handleDynamicAction(params.row)} disabled={!roleaccess.UPDATE}>Edit</button> 
                                                     )
                                                 }
     
                                                 columns.push(data);
                                                 break;
                                             };
                                     case "button-custom":
                                                 {
                                                   
                                                    var data = {
                                                       //  flex: 1,
                                                         field:"action",
                                                         headerName:'',
                                                         width: width[count],
                                                         renderCell:(params) =>(
                                                             
                                                             <button className='btn btn-primary' title={newRows[name][0][key]} onClick={(e) => handleDynamicAction(e,params.row)} disabled={!roleaccess.READ} type='button'>{newRows[name][0][key]}</button> 
                                                         )
                                                     }
         
                                                     columns.push(data);
                                                     break;
                                                 };
                                     default:{
                                         var data = { field: `${key}`, headerName: `${key.replaceAll('_',' ')}`,  width: width[count], valueGetter:({ value }) => {
                                             if(value)
                                             {
                                                 
                                                 //console.log(key, (rows[0][key]).toString())
                                                 if(typeof newRows[0][key] == "string" && new Date((newRows[name][0][key]).toString()) != "Invalid Date"){
                                                    // return "hai"
                                                     return Helper.GetDateDDMMYYYY(value);
                                                 }else if(isNaN(newRows[0][key])== false && (typeof newRows[name][0][key] == "number")){
                                                     //return "hei"
                                                     return Helper.formatAsCurrency(value);
                                                 }else{
                                                     return value;
                                                 }
                                               
                                             }
                                         }}
 
                                         columns.push(data);
                                         break;
                                     }
                                 }
                                 count++;
                             }
                         setNewColumn({[name] : columns})
                        
                     }else{
                         setNewColumn({[name] : customcolumns})
                         
                     }
                   //  alert(filterModel[name].quickFilterValues.length)
                   //  console.log(filterModel[name])
                   
                  //  console.log(filterModel[name].quickFilterValues.length)  
                  var currentPage = Math.ceil((rows.length) / selectedRowPerPage[name])
              //    alert(rows.length)
                     let page = gridPage[name]
                      
                     if(gridPage[name] > currentPage){
                        //setGridPage(prev => ({[name]: prev[name] - 1}));
                        setGridPage({[name]: currentPage});
                        page = currentPage
                     }
                   // setPage(gridPage[name], filterModel[name].quickFilterValues.length == 0 ? newRow : newRows[name])
                    setPage(page, filterModel[name].quickFilterValues.length == 0 ? newRow : newRows[name])
                 }else{
                    //alert('hiii')
                     setNewRows({[name] : rows})
                    setTotalRows({[name] : 1})
                    setPage(1,rows)
                 }

                
        } 

        const setPage = (page, row) =>{
            if(sortModel[name].length > 0){
                row =  Helper.ArraySort(row, sortModel[name][0].field,sortModel[name][0].sort)
            }
           
            const newRowstemp1 = row.map(function(item,index) 
            {  
                 let newObj={}
                        for(let key in item){
                           
                            let tanggal1 =  String(item[key]).split("-")
                           
                            if(tanggal1.length == 3){
                                if((isNumber(parseInt(tanggal1[0])) && tanggal1[0].length == 4) && (isNumber(parseInt(tanggal1[1])) && tanggal1[1].length == 2) &&  (isNumber(parseInt(String(tanggal1[2]).split("T")[0])) && String(tanggal1[2]).split("T")[0].length == 2)){
                                    if(new Date(item[key]) != "Invalid Date"){
                                        newObj[key] = Helper.GetDateDDMMYYYY(new Date(item[key])) 
                                        continue;
                                    }
                                }
                            }
                           
                        }

                         return {
                            ...item,
                            ...newObj,
                           rowNumber:  index + 1,
                         }
                     }).slice((page - 1) * parseInt(selectedRowPerPage[name]), ((page - 1) * parseInt(selectedRowPerPage[name])) + parseInt(selectedRowPerPage[name]))
            
            setNewRowsTemp({[name] :  [...newRowstemp1]})
            setGridPage({[name] :parseInt(page)})
            setPaginationModel({[name] : { pageSize : parseInt(selectedRowPerPage[name]), page: 0}})
        }
 

        useEffect(() => {
            Grid();
          //  console.log("haiiii")
          // console.log(rows)
        }, [customcolumns, rows, selectedRowPerPage[name], sortModel[name]]);

        useEffect(()=>{
             setIsLoading({[name]:true})
             setTimeout(() => {
                setIsLoading({[name]:false})
            }, 1000);
        },[rows])

       function getRowId(row) {
            if(rowid != null && rowid!='')
            {
                for(let key in row) {
                    if(key == rowid){
                       return row[key] 
                    }
                }
            }
 
            return row.id;
        }

        const handlePaging =(e, page)=>
        { 
            setIsLoading({[name] :true})
            
            setPage(parseInt(page), newRows[name])
            setTimeout(() => {
                
                setIsLoading({[name] :false})
              
            }, 1000)
          
        }

        const handleModelChange = (model) => {
           
            if(model.quickFilterValues.length == 0)
            {
                setTotalRows({[name] : Math.ceil(rows.length / parseInt(selectedRowPerPage[name]))})
                setNewRows({[name] : rows})
                setPage(1, rows)
            }else{
                const newRowsTemp2 = [...rows]
             
                let griddata =  newRowsTemp2.filter((item) => {
                        let isMatch = 0;
                 
                        for(let key in item){
                            if(newColumn[name].some((data) => data.field == key))
                            {
                                if(item[key] !== undefined && item[key] !== null && item[key].toString().toLowerCase().includes(model.quickFilterValues[0].toLowerCase().trim())) 
                                { 
                                    isMatch++;
                                }
                            }
                        }
                  
                        if(isMatch > 0){
                            isMatch = 0;
                            return true;
                        } 
 
                        return false;
                })
 
                setTotalRows({[name] : Math.ceil(griddata.length / parseInt(selectedRowPerPage[name]))})
                setNewRows({[name] :  [...griddata]})
                setPage(1, [...griddata])
            }
        }

        const [paginationModel, setPaginationModel] = React.useState({[name] :{
                pageSize: 25,
                page: 0,
        }});

         const columns = React.useMemo(() =>
                            newColumn[name].map((col) =>
                                disabledfieldsort.includes(col.field) ? { ...col, sortable: false } : col,
                            ),
                            [newColumn[name]],
        );

        return( 
            <>
            <Box border={1} borderColor={'lightgray'} sx={{ position: 'relative'  }}>
            
             {/* <Stack marginTop={1} marginLeft={0.5} marginBottom={1}>
                <table style={{fontSize:11}}> 
                    <tr>
                        <td><Pagination  page={gridPage[name]} id="pagination" count={totalRows[name]} variant="outlined" shape="rounded" onChange={handlePaging} showFirstButton showLastButton/></td>
                        <td style={{textAlign:right,paddingTop:6}}>{(parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + 1} - {newRows[name].length > ((parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + parseInt(selectedRowPerPage[name])) ? ((parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + parseInt(selectedRowPerPage[name])) : newRows[name].length} of {newRows[name].length} </td>
                        <td style={{width:200}}><table width={"100%"} border="0" cellPadding={0} cellSpacing={0} >
                                <tr>
                                    <td style={{textAlign:right, paddingTop:5,paddingRight:5}}>row per page </td>
                                    <td style={{width:70,paddingRight:5}}><select id="opt" name="opt" className='form-control' style={{height:25, fontSize:11}} value={selectedRowPerPage[name]} onChange={(item => {
                                            setPaginationModel({[name] : {pageSize : parseInt(document.getElementById("opt").value), page:0}})
                                            setSelectedRowPerPage({[name] : parseInt(document.getElementById("opt").value)})
                                          
                                        })}>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                       </select></td>
                                </tr>
                            </table> 
                       </td>
                    </tr>
                </table>
                
            </Stack> */}
            <Stack marginTop={1} marginLeft={0.5} marginBottom={1}>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-6 mb-8">
                    <div className='lg:col-span-5'><Pagination  page={gridPage[name]} id="pagination" count={totalRows[name]} variant="outlined" shape="rounded" onChange={handlePaging} showFirstButton showLastButton/></div>
                    <div className='text-lg mt-2'>{(parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + 1} - {newRows[name].length > ((parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + parseInt(selectedRowPerPage[name])) ? ((parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + parseInt(selectedRowPerPage[name])) : newRows[name].length} of {newRows[name].length} </div>
                    <div className='mr-5'><select id="opt" name="opt" className='form-control' style={{height:25, fontSize:11}} value={selectedRowPerPage[name]} onChange={(item => {
                                            setPaginationModel({[name] : {pageSize : parseInt(document.getElementById("opt").value), page:0}})
                                            setSelectedRowPerPage({[name] : parseInt(document.getElementById("opt").value)})
                                          
                                        })}>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                       </select></div>
                </div>
             </Stack>
            <Stack marginBottom={1} sx={{position:'relative'}}>
                {isLoading[name] && ( 
                <>
                <div style={{position:'absolute', top:0, left:0,width:"100%"}}>
                 {(() => {
                        let rowHeight = 0;
                        const arr = [];
                        if(selectedRowPerPage[name] == 25){
                            rowHeight = parseInt(selectedRowPerPage[name])  
                        }else if(selectedRowPerPage[name] == 50){
                            rowHeight = parseInt(selectedRowPerPage[name])  
                        }else{
                            rowHeight = parseInt(selectedRowPerPage[name])  
                        }
 
                        if(newRowsTemp[name].length < 25){
                            rowHeight = parseFloat(newRowsTemp[name].length) 
                        }
 
                        arr.push(<Skeleton variant="rounded" animation="wave" height={85} sx={{opacity:0.6}} />)
                        for (let i = 0; i < rowHeight; i++) {
                            arr.push(
                                <Skeleton variant="rounded" animation="wave" height={52} sx={{opacity:0.6}} />
                            );
                        }
                        return arr;
                })()}
                
                </div>

                <div style={{position:"absolute",top:"15%",left:"50%",zIndex:1}}>
                    <CircularProgress color='info' size="50px"></CircularProgress> 
                </div> 
 
                  </>   
            )}
                <StripedDataGrid className='fonty'
                       //columns={newColumn[name]}
                        columns = {columns}
                       rows={newRowsTemp[name]}
                       disableColumnFilter
                       disableDensitySelector
                       disableColumnSelector
                       slots={{ toolbar: GridToolbar }}
                      // sx={{visibility: isLoading[name] ? 'hidden' : 'visible'}}
                       //filterModel={filterModel[name]}
                       filterMode='server'
                       onFilterModelChange={(newModel, details) => {
                            var data = {
                                [name] : newModel
                            }
                             setGridPage({[name] : 1})
                             setFilterModel({[name]:newModel})
                             setIsLoading({[name] :true})
                             handleModelChange(newModel)
                             setTimeout(() => {
                               
                               setIsLoading({[name] :false})
                               
                           }, 1000);
                            
                       }}

                       slotProps={{ toolbar: { showQuickFilter: true, printOptions: { 
                                                disableToolbarButton: true },
                                                csvOptions: { disableToolbarButton: true },} }}
                       columnVisibilityModel={columnVisibilityModel[name]}
                       onColumnVisibilityModelChange={(newModel) =>
                       {
                            var data = {
                                [name] : newModel
                            }
                            setColumnVisibilityModel(data)
                       }
                        
                       }
                        sortingMode='server'
                        sortModel={sortModel[name]}
                        onSortModelChange={(newSortModel) => {
                          
                             setSortModel({[name] : newSortModel})
                             setIsLoading({[name] :true})
                         
                             setTimeout(() => {
                               
                               setIsLoading({[name] :false})
                               
                           }, 1000);
                        }}
                        sortingOrder={['desc', 'asc']}
                        getRowId={getRowId}
                        id={name}
                        hideFooterPagination={true}
                        hideFooter={true}
                        paginationModel={paginationModel[name]}
                        onPaginationModelChange={(e)=> {
                           
                        }}
                      
                        pageSizeOptions={[25, 50, 100]}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                        }
                        width="100%"
            />
            </Stack>
        
             {/* <Stack marginBottom={1} marginLeft={0.5}>
                <table style={{fontSize:11}}> 
                    <tr>
                        <td><Pagination  page={gridPage[name]} id="pagination" count={totalRows[name]} variant="outlined" shape="rounded" onChange={handlePaging} showFirstButton showLastButton/></td>
                        <td style={{textAlign:right,paddingTop:6}}>{(parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + 1} - {newRows[name].length > ((parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + parseInt(selectedRowPerPage[name])) ? ((parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + parseInt(selectedRowPerPage[name])) : newRows[name].length} of {newRows[name].length} </td>
                        <td style={{width:200}}><table width={"100%"} border="0" cellPadding={0} cellSpacing={0} >
                                <tr>
                                    <td style={{textAlign:right, paddingTop:5,paddingRight:5}}>row per page </td>
                                    <td style={{width:70,paddingRight:5}}><select id="opt2" name="opt2" className='form-control' style={{height:25, fontSize:11}} value={selectedRowPerPage[name]} onChange={(item => {
                                            setPaginationModel({[name] : {pageSize : parseInt(document.getElementById("opt2").value), page:0}})
                                            setSelectedRowPerPage({[name] : parseInt(document.getElementById("opt2").value)})
                                          
                                        })}>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                       </select></td>
                                </tr>
                            </table> 
                       </td>
                    </tr>
                </table>
                
            </Stack> */}
           <Stack marginTop={1} marginLeft={0.5} marginBottom={1}>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-6 mb-8">
                    <div className='lg:col-span-5'><Pagination  page={gridPage[name]} id="pagination" count={totalRows[name]} variant="outlined" shape="rounded" onChange={handlePaging} showFirstButton showLastButton/></div>
                    <div className='text-lg mt-2'>{(parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + 1} - {newRows[name].length > ((parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + parseInt(selectedRowPerPage[name])) ? ((parseInt(gridPage[name]-1) * parseInt(selectedRowPerPage[name])) + parseInt(selectedRowPerPage[name])) : newRows[name].length} of {newRows[name].length} </div>
                    <div className='mr-5'><select id="opt2" name="opt" className='form-control' style={{height:25, fontSize:11}} value={selectedRowPerPage[name]} onChange={(item => {
                                            setPaginationModel({[name] : {pageSize : parseInt(document.getElementById("opt2").value), page:0}})
                                            setSelectedRowPerPage({[name] : parseInt(document.getElementById("opt2").value)})
                                          
                                        })}>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                       </select></div>
                </div>
             </Stack>
             
            </Box>
            </>
        )
    }
    
   export default  GridNumberPaging